// export const domain = "http://127.0.0.1:8000/api";
// export const domain = "https://somboonapi.kisrateam.com/api";
export const domain = "https://somboonapi.kisrasprint.com/api";
// export const domain = "https://sbpack.co/somboon/api";
